<template>
  <div>
    <dashboard-dados-coleta
      title="Dose única"
      :dataset-municipios-geral-estado="dadosVacinacaoMunicipiosGeral"
      :dataset-municipios-estado="dadosVacinacaoMunicipios"
      :dataset-coordenadorias-geral-estado="dadosVacinacaoCoordenadoriasGeralEstado"
      :dataset-coordenadorias-estado="dadosVacinacaoCoordenadoriasEstado"
      :risk-levels="niveisRiscoVacinacao"
      initial-dataset-name="municipios">
      <template #chart-explanation>
        <text-expandable
          label="Entenda o que é o indicador"
          content-id="entenda-vacinacao-hpv">
          <texto-explicativo-vacinacao-hpv />
        </text-expandable>
      </template>
    </dashboard-dados-coleta>
  </div>
</template>

<script>
import DashboardDadosColeta from '@/components/DashboardDadosColeta/DashboardDadosColeta.vue';
import TextExpandable from '@/components/TextExpandable/TextExpandable.vue';
import TextoExplicativoVacinacaoHpv from '@/components/CancerColoUtero/DashboardVacinacaoHpv/TextoExplicativoVacinacaoHpv.vue';
import DadosVacinacaoHpvMunicipios from '@/assets/chart-data/cancer-colo-utero/vacinacao-hpv/municipios.json';
import DadosVacinacaoHpvMunicipiosGeral from '@/assets/chart-data/cancer-colo-utero/vacinacao-hpv/municipios-geral.json';
import DadosVacinacaoHpvCoordenadorias from '@/assets/chart-data/cancer-colo-utero/vacinacao-hpv/coordenadorias.json';
import DadosVacinacaoHpvCoordenadoriasGeral from '@/assets/chart-data/cancer-colo-utero/vacinacao-hpv/coordenadorias-geral.json';

export default {
  name: 'dashboard-vacinacao-hpv',
  components: {
    'dashboard-dados-coleta': DashboardDadosColeta,
    'text-expandable': TextExpandable,
    'texto-explicativo-vacinacao-hpv': TextoExplicativoVacinacaoHpv,
  },
  data: () => ({
    dadosVacinacaoMunicipios: DadosVacinacaoHpvMunicipios,
    dadosVacinacaoMunicipiosGeral: DadosVacinacaoHpvMunicipiosGeral,
    dadosVacinacaoCoordenadoriasGeralEstado: DadosVacinacaoHpvCoordenadoriasGeral,
    dadosVacinacaoCoordenadoriasEstado: DadosVacinacaoHpvCoordenadorias,
    niveisRiscoVacinacao: {
      bad: {
        riskRule: (value) => value < 50,
        riskTitle: 'Muito abaixo da meta',
        riskDataValue: 'Menor que 50%',
        resourceLink: '/planos-de-acao/cancer-colo-utero/vacinacao-hpv/cobertura-vacinacao-hpv-muito-abaixo.pdf',
        resourceLinkLabel: 'Baixar PDF',
      },
      average: {
        riskRule: (value) => value >= 50 && value < 80,
        riskTitle: 'Abaixo da meta',
        riskDataValue: '50% a 79%',
        resourceLink: '/planos-de-acao/cancer-colo-utero/vacinacao-hpv/cobertura-vacinacao-hpv-abaixo.pdf',
        resourceLinkLabel: 'Baixar PDF',
      },
      good: {
        riskRule: (value) => value >= 80,
        riskTitle: 'Meta atingida',
        riskDataValue: 'Maior que 80%',
        resourceLink: '/planos-de-acao/cancer-colo-utero/vacinacao-hpv/cobertura-vacinacao-hpv-atingida.pdf',
        resourceLinkLabel: 'Baixar PDF',
      },
    },
  }),
};
</script>
